import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Grid from '@material-ui/core/Grid';
import getDateFromString from "../../utils/getDateFromString";
import {useSelector, useDispatch} from "react-redux";
import { getTask, unclaimTask, claimTask } from "../../store/action/taskAction";
import { fetchMessageEvents } from "../../store/action/communicationChannel";

const useStyles = makeStyles((theme) => ({
    paper: {
        width: "100%",
        borderRadius: '11px',
        boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.06)',
        marginBottom: 20,
        opacity: props => props.disabled ? 0.5 : 1,
        pointerEvents: props => props.disabled ? 'none' : 'auto'
    },
    tableWrapper: {
        padding: "30px",
        width: "100%",
        alignItems: 'center'
    },
    title: {
        fontFamily: 'Poppins',
        fontSize: '12.81px',
        fontWeight: 500,
        lineHeight: '19.22px',
        textAlign: 'left',
        color: 'rgba(181, 181, 195, 1)',
        padding: '3px'
    },
    item: {
        fontFamily: 'Poppins',
        fontSize: '13.8px',
        fontWeight: 600,
        lineHeight: '20.7px',
        textAlign: 'left',
        color: 'rgba(63, 66, 84, 1)',
        padding: '3px'
    },
    button: {
        background: 'none',
        border: 'none',
        padding: 0,
        margin: 0,
        cursor: 'pointer',
    },
    eventBody: {
        fontFamily: 'Poppins',
        fontSize: '12px',
        lineHeight: '18px',
        color: 'rgba(255, 168, 0, 1)',
        fontWeight: 700,
        paddingTop: '0'
    }
}));
const TaskInformation = ({ taskId, onClaimStatusChange }) => { 
    const dispatch = useDispatch();
    const username = localStorage.getItem('username');
    const [isDisabled, setIsDisabled] = useState(false);
    //const [task, setTask] = useState({});
    const taskReducer = useSelector((state) => state.taskReducer.taskList.find(task => task?.taskId === taskId));
    const [task, setTask] = useState(taskReducer);
    const [messageEvents, setMessageEvents] = useState([]);

    const fetchTask = async () => {
        try {
            const response = await getTask(taskId, username);
            setTask(response);
            if (response?.assignee === username) {
                setIsDisabled(false);
                onClaimStatusChange(false);
            } else {
                setIsDisabled(true);
                onClaimStatusChange(true);
            }
             if (response?.businessKey) {
                const events = await dispatch(fetchMessageEvents("STEP_SERVICE_PROPOSAL", response.businessKey));
                setMessageEvents(events);
            }
        } catch (error) {
            console.error(`Error fetching task details: ${error.message}`);
        }
    };

    useEffect(() => {
        fetchTask()
    }, []);

    const handleClaimOrUnclaim = async () => {
            if (task?.assignee === username) {
                await dispatch(unclaimTask(task?.id, task?.assignee));
            } else {
                await dispatch(claimTask(task?.id, username));
            }
            fetchTask()
    };

    const classes = useStyles();

    return (
        <Paper className={classes.paper}>
            {task ? (
                <Grid container direction="row" justifyContent="space-between" alignItems="center" className={classes.tableWrapper}>
                    <Grid item xs="auto">
                        <div className={classes.title}>Action</div>
                        <div className={classes.item} style={{ display: 'flex', alignItems: 'center' }}>
                            <div style={{
                                height: '26px', borderRadius: '51px', background: 'rgba(240, 243, 199, 1)', textAlign: 'center', padding: '5px 10px',
                                fontFamily: 'Poppins', fontSize: '10.69px', fontWeight: 600, lineHeight: '16.03px', color: 'rgba(187, 200, 8, 1)', whiteSpace: 'nowrap',
                            }}>
                                {task?.name}
                            </div>
                        </div>
                        {messageEvents.length > 0 && (
                            <div className={classes.eventBody}>
                                {messageEvents.map((event, index) => (
                                    <div key={index}>
                                        <p style={{margin:"0px",marginLeft:"5px"}}>{event.body}</p>
                                    </div>
                                ))}
                            </div>
                        )}
                    </Grid>
                    <Grid item xs>
                        <Grid container>
                            <Grid item xs='auto'  style={{ marginLeft: 25 }}>
                                <div className={classes.title}>N° Sinistre</div>
                                <div className={classes.item} style={{ color: 'rgba(187, 200, 8, 1)' }}><u>{task?.businessKey || ""}</u></div>
                            </Grid>
                            <Grid item xs='auto' style={{ marginLeft: 25 , }}>
                                <div className={classes.title}>Contact client</div>
                                <div className={classes.item}>{task?.variables?.customerContact?.value}</div>
                            </Grid>
                            <Grid item xs='auto' style={{ marginLeft: 25 , }}>
                                <div className={classes.title}>Date Création</div>
                                <div className={classes.item}>{getDateFromString(task?.created?.toString())}</div>
                            </Grid>
                           
                            <Grid item xs='auto' style={{ marginLeft: 25 , }}>
                                <div className={classes.title}>Responsable</div>
                                <div className={classes.item}>{task?.assignee || ""}</div>
                            </Grid>
                        </Grid>
                    </Grid>

                    <Grid item xs="auto">
                        <button className={classes.button} onClick={handleClaimOrUnclaim}>
                            <div className={classes.item} style={{ display: 'flex', alignItems: 'center' }}>
                                <div style={{
                                    marginLeft: '10px',
                                    height: '26px',
                                    borderRadius: 4.79,
                                    background: task?.assignee === username ? 'rgba(255, 229, 229, 1)' : 'rgba(240, 243, 199, 1)',
                                    textAlign: 'center',
                                    padding: '5px 10px',
                                    fontFamily: 'Poppins',
                                    fontSize: '10.69px',
                                    fontWeight: 600,
                                    lineHeight: '16.03px',
                                    color: task?.assignee === username ? 'rgba(255, 54, 54, 1)' : 'rgba(187, 200, 8, 1)',
                                    whiteSpace: 'nowrap',
                                }}>
                                    {task?.assignee === username ? 'Annuler la prise en charge' : 'Prendre en charge'}
                                </div>
                            </div>
                        </button>
                    </Grid>
                </Grid>
            ) : (
                <p>Loading...</p>
            )}
        </Paper>
    );
}

export default TaskInformation;